import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Subscription } from 'rxjs/internal/Subscription';
import { AuthService } from '../../auth/service/auth.service';
import { Setting } from '../../common/settings';
import { OrganisationService } from '../../organisation/organisation/services/organisation.service';
import url from 'src/settings.json';
import { Observable } from 'rxjs';
import { Config } from '../Model/configurationModel';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService implements OnDestroy {
  currentOrganisation: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      //Authorization: 'my-auth-token'
    }),
    params: new HttpParams()
  };
  public countEmitter = new BehaviorSubject<number>(-1);
  organisationSubscriber: Subscription;
  setting: Setting = url;
  currentUser: any;

  constructor(private readonly httpClient: HttpClient,
    private readonly oAuthService: AuthService,
    private readonly organisationService: OrganisationService) {
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; }
      }
    });
    this.currentUser = this.oAuthService.claims;   
  }
  public GetSmtpConfiguration(): Observable<Config>{
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    return this.httpClient.get<Config>(`${url}/api/config`, { headers: headers });
  }

  public updateSmtpConfiguration(smtpConfig:any){
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    this.httpOptions.headers = this.httpOptions.headers.set('Content-Type', 'application/json').set('Authorization', `Bearer ${token}`)
    return this.httpClient.patch(`${url}/api/config`, smtpConfig, this.httpOptions);
  }
  ngOnDestroy(): void {
    this.organisationSubscriber.unsubscribe();
  }
}

